// extracted by mini-css-extract-plugin
export default {"BannerSlideSecond":"BannerSlideSecond_BannerSlideSecond__q6H3C","buttom":"BannerSlideSecond_buttom__mn9SZ"};